/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, breakpoints } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import { FootnoteContext, createAnchor } from 'bundles/ent-website/components/FootnoteContext';
import { MAX_PAGE_CONTAINER_WIDTH } from 'bundles/ent-website/constants/layout';

import _t from 'i18n!nls/ent-website';

function FootnoteList() {
  const styles = {
    container: css`
      max-width: ${breakpoints.values[MAX_PAGE_CONTAINER_WIDTH]}px;
      padding: 0 var(--cds-spacing-800);
      margin: var(--cds-spacing-200) auto var(--cds-spacing-400);
    `,

    header: css`
      font-size: 12px;
      margin-bottom: var(--cds-spacing-100);
      border-top: 1px solid var(--cds-color-grey-50);
      padding-top: var(--cds-spacing-200);
    `,

    footnotes: css`
      padding-left: var(--cds-spacing-300);
      color: var(--cds-color-grey-975);

      li {
        line-height: 16px !important;

        div,
        p {
          display: inline;
          font-size: 11px !important;
          line-height: 16px !important;
        }

        a {
          color: var(--cds-color-grey-975);

          &:link,
          &:visited {
            color: var(--cds-color-grey-975);
          }
        }

        &::marker {
          font-size: 11px;
          content: '[' attr(data-num) ']  ';
        }
      }
    `,
  };

  const { getAllFootnotes } = React.useContext(FootnoteContext);

  const footnotes = getAllFootnotes();

  if (footnotes.length <= 0) {
    return null;
  }

  return (
    <Grid container css={styles.container}>
      <Grid item xs={12} css={styles.header}>
        {_t('Source')}
      </Grid>
      <Grid item xs={12}>
        <ol css={styles.footnotes}>
          {footnotes.map((entry) => (
            <li key={entry.key} data-num={entry.num} id={createAnchor(entry.num)}>
              <Markdown source={entry.footnote} />
            </li>
          ))}
        </ol>
      </Grid>
    </Grid>
  );
}

export default FootnoteList;
